import React from 'react';
import { Heart } from 'lucide-react';

const MOOD_EMOJIS = {
  uncloned: '🐑', magical: '✨', amazing: '🌟', loved: '💖',
  on_fire: '🔥', hopeful: '🌈', dreamy: '💫', free: '🦋',
  peaceful: '🌸', energized: '⚡', calm: '🌙', thoughtful: '💭',
  focused: '🎯', tired: '😴', melancholy: '🌧️', strong: '💪',
  angry: '😤', sad: '😢', grateful: '🙏', creative: '🎨', happy: '😊'
};

const MOOD_LABELS = {
  uncloned: 'Custom', custom_branded: 'Custom', on_fire: 'On Fire', magical: 'Magical', amazing: 'Amazing',
  loved: 'Loved', hopeful: 'Hopeful', dreamy: 'Dreamy', free: 'Free',
  peaceful: 'Peaceful', energized: 'Energized', calm: 'Calm', thoughtful: 'Thoughtful',
  focused: 'Focused', tired: 'Tired', melancholy: 'Melancholy', strong: 'Strong',
  angry: 'Angry', sad: 'Sad', grateful: 'Grateful', creative: 'Creative', happy: 'Happy'
};

const MoodChart = ({ data, customMood = null }) => {
  const total = Object.values(data || {}).reduce((a, b) => a + b, 0) || 1;
  const sorted = Object.entries(data || {}).sort((a, b) => b[1] - a[1]);
  
  // Helper to get mood label - uses custom mood label for "uncloned" or "custom_branded" if available
  const getMoodLabel = (mood) => {
    if ((mood === 'uncloned' || mood === 'custom_branded') && customMood?.enabled && customMood?.label) {
      return customMood.label;
    }
    return MOOD_LABELS[mood] || mood;
  };
  
  // Helper to get mood emoji/image
  const getMoodDisplay = (mood) => {
    if ((mood === 'uncloned' || mood === 'custom_branded') && customMood?.enabled && customMood?.imageUrl) {
      return <img src={customMood.imageUrl} alt={customMood.label || 'Custom'} className="w-6 h-6 object-contain" />;
    }
    return <span className="text-lg w-6">{MOOD_EMOJIS[mood] || '😊'}</span>;
  };
  
  return (
    <div className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-4">
      <h3 className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
        <Heart className="w-4 h-4 text-[#df1283]" />
        Mood Distribution
      </h3>
      <div className="space-y-2">
        {sorted.slice(0, 5).map(([mood, count]) => (
          <div key={mood} className="flex items-center gap-2">
            {getMoodDisplay(mood)}
            <span className="text-xs text-[#FDF2F8]/70 flex-1">{getMoodLabel(mood)}</span>
            <div className="w-16 h-1.5 bg-[#4A0A66] rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-[#df1283] to-[#FF7901] rounded-full"
                style={{ width: `${(count / total) * 100}%` }}
              />
            </div>
            <span className="text-xs text-[#FDF2F8]/50 w-6 text-right">{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export { MOOD_EMOJIS, MOOD_LABELS };
export default MoodChart;
